import React, { useState } from 'react';
import AnnoucementIcon from '../assets/annoucement_icon.png';
import AnnouncementModal from './AnnouncementModal';

export default function AnnouncementButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'absolute',
          top: 248,
          right: 0,
          zIndex: 1200,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
        }}
      >
        <img src={AnnoucementIcon} alt="Annoucement" style={{ width: 70, height: 70 }} />
      </button>
      <AnnouncementModal
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
